import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { withContainerContext } from "../../components/container/ContainerContext";
import Icon from "../../components/interface/Icon";
import { PropTypeShapes } from "../../types";

class TimelineGroupHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this._scrollListeners = {
      switchToFixedPosition: this.switchToFixedPosition.bind(this),
      switchToAbsolutePosition: this.switchToAbsolutePosition.bind(this)
    };

    this._domNode = null;
    this._isFixedPosition = false;
  }

  componentDidMount() {
    this._fixedLeft = this.props.left;
    this._fixedTop = this.props.top;
    this.props.registerScrollListener(this.props.id, this._scrollListeners);
    this.applyStyle();
  }

  componentDidUpdate() {
    this.applyStyle();
  }

  componentWillUnmount() {
    this.props.unregisterScrollListener(this.props.id);
  }

  switchToFixedPosition(left, top) {
    this._isFixedPosition = true;
    this._fixedLeft = left;
    this._fixedTop = top;
    this.applyStyle();
  }

  switchToAbsolutePosition(left, top) {
    this._isFixedPosition = false;
    this._fixedLeft = left;
    this._fixedTop = top;
    this.applyStyle();
  }

  applyStyle() {
    const styles = this.getStyle();
    this._domNode.style.position = styles.nodeStyle.position;
    this._domNode.style.left = styles.nodeStyle.left;
    this._domNode.style.width = styles.nodeStyle.width;
    this._domNode.style.top = styles.nodeStyle.top;
    this._domNode.style.overflow = styles.nodeStyle.overflow;
    this._transformNode.style.transform = styles.transformStyle.transform;
  }

  getStyle() {
    if (this._isFixedPosition) {
      // When scrolling horizontally:
      //  - item should become fixed at its last known top position

      // Because on Chome position:fixed is eelvanted to its own stacking context and will
      // display on top of other content in other views, we work around this by:
      // 1) Constraining the node's y position to be within our containerRect
      // 2) Apply a transform on its contents to move it the rest of the way
      // 3) But the node has overflow hidden, so any part that moves outside the view will
      //    not be visible.
      const headerBottom = this._fixedTop + this.props.height;
      const minTop = this.props.containerRect.top;
      const maxTop = this.props.containerRect.bottom - this.props.height;
      const nodeTop = Math.min(Math.max(minTop, this._fixedTop), maxTop);
      const outOfRange =
        headerBottom < this.props.containerRect.top || this._fixedTop > this.props.containerRect.bottom;

      return {
        nodeStyle: {
          position: "fixed",
          left: `${this.props.containerRect.left}px`,
          width: `${this.props.containerRect.width}px`,
          top: `${nodeTop}px`,
          overflow: "hidden",
          display: outOfRange ? "none" : null
        },
        transformStyle: {
          transform: `translateY(${this._fixedTop - nodeTop}px)`
        }
      };
    } else {
      return {
        nodeStyle: {
          position: "absolute",
          left: `${this._fixedLeft}px`,
          width: `${this.props.containerRect.width}px`,
          top: `${this._fixedTop}px`,
          overflow: null,
          display: null
        },
        transformStyle: {
          transform: null
        }
      };
    }
  }

  render() {
    const style = this.getStyle();

    return (
      <div className="timelineGroupHeaderView" style={style} ref={node => (this._domNode = node)}>
        <div className="timelineGroupHeaderTransformDiv" ref={node => (this._transformNode = node)}>
          <Icon icon={this.props.icon} color={this.props.iconColor} />
          <span>{this.props.label}</span>
        </div>
      </div>
    );
  }
}

TimelineGroupHeaderView.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  top: PropTypes.number,
  left: PropTypes.number,
  height: PropTypes.number,
  registerScrollListener: PropTypes.func,
  unregisterScrollListener: PropTypes.func,

  // From withContainerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(TimelineGroupHeaderView);
